var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgLogoBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 94,
    viewBox: "0 0 96 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 94,
    rx: 47,
    fill: "#C3D9FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_2655_13620)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.5,
    cy: 70,
    rx: 20.5,
    ry: 6,
    fill: "#7E7D99",
    fillOpacity: 0.77
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.625 23.6689H23.375C21.5111 23.6689 20 25.18 20 27.0439V58.955C20 60.8189 21.5111 62.33 23.375 62.33H72.625C74.4889 62.33 76 60.8189 76 58.955V27.0439C76 25.18 74.4889 23.6689 72.625 23.6689Z",
    fill: "#274D79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8301 33.0862V38.5828C58.8301 39.4459 59.5298 40.1455 60.3928 40.1455H69.015C69.8781 40.1455 70.5777 39.4458 70.5777 38.5828V33.0862C70.5777 32.223 69.878 31.5234 69.015 31.5234H60.3929C59.5298 31.5234 58.8301 32.2231 58.8301 33.0862Z",
    fill: "#C4573A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5354 29.2168H27.9647C28.4456 29.2168 28.8042 29.2369 29.0405 29.2769C29.2768 29.317 29.4882 29.4006 29.6748 29.5277C29.8613 29.6548 30.0168 29.8242 30.1411 30.0356C30.2655 30.247 30.3277 30.484 30.3277 30.7465C30.3277 31.0311 30.251 31.2923 30.0976 31.53C29.9442 31.7678 29.7362 31.9459 29.4738 32.0648C29.8441 32.1725 30.1287 32.3563 30.3277 32.6162C30.5267 32.8759 30.6262 33.1813 30.6262 33.5323C30.6262 33.8087 30.562 34.0775 30.4334 34.3387C30.3049 34.5998 30.1294 34.8085 29.9069 34.9647C29.6845 35.1209 29.4101 35.2169 29.084 35.2528C28.8795 35.2749 28.3861 35.2886 27.6041 35.2943H25.5354V29.2168ZM26.7624 30.2282V31.6336H27.5666C28.0447 31.6336 28.3419 31.6266 28.4579 31.6129C28.6679 31.588 28.833 31.5154 28.9533 31.3952C29.0736 31.2751 29.1337 31.1169 29.1337 30.9206C29.1337 30.7326 29.0819 30.58 28.9782 30.4625C28.8745 30.3449 28.7205 30.2739 28.516 30.249C28.3944 30.2352 28.0449 30.2284 27.4671 30.2284H26.7624V30.2282ZM26.7624 32.6451V34.2703H27.8984C28.3406 34.2703 28.6211 34.2578 28.7399 34.233C28.9222 34.1998 29.0709 34.119 29.1856 33.9904C29.3002 33.8619 29.3576 33.6899 29.3576 33.4743C29.3576 33.292 29.3134 33.1371 29.225 33.01C29.1367 32.8829 29.0088 32.7903 28.8415 32.7322C28.6742 32.6741 28.3115 32.6451 27.7533 32.6451H26.7624Z",
    fill: "#EBF0F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.143 35.2943H35.808L35.2775 33.9138H32.8481L32.3465 35.2943H31.0447L33.4118 29.2168H34.7094L37.143 35.2943ZM34.8835 32.8898L34.0461 30.6346L33.2253 32.8898H34.8835Z",
    fill: "#EBF0F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8062 35.2943V29.2168H39.0001L41.4874 33.2753V29.2168H42.6274V35.2943H41.3962L38.9461 31.331V35.2943H37.8062Z",
    fill: "#EBF0F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9419 35.2943V29.2168H45.1689V31.9156L47.648 29.2168H49.298L47.0097 31.5839L49.4224 35.2943H47.8346L46.1639 32.4421L45.1689 33.4577V35.2943H43.9419Z",
    fill: "#EBF0F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8109 53.8193H23.0554V56.7844H27.8109V53.8193Z",
    fill: "#EBF0F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1745 53.8193H31.678V56.7844H39.1745V53.8193Z",
    fill: "#EBF0F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9108 53.8193H41.4443V56.7844H49.9108V53.8193Z",
    fill: "#EBF0F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5779 53.8193H52.7114V56.7844H62.5779V53.8193Z",
    fill: "#EBF0F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9447 53.8193H65.811V56.7844H72.9447V53.8193Z",
    fill: "#EBF0F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2655_13620",
    x: 13,
    y: 50,
    width: 69,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_2655_13620"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogoBank);
export default __webpack_public_path__ + "static/media/ImgLogoBank.0a1ab16c4ab07c2844779c0c28f70172.svg";
export { ForwardRef as ReactComponent };